import React, { Component } from 'react';
import { Button, Modal, ModalHeader, ModalBody, Input, InputGroup } from 'reactstrap';
import {
  TwitterIcon,
  FacebookIcon,
  GooglePlusIcon,
  TwitterShareButton,
  FacebookShareButton,
  GooglePlusShareButton,
} from 'react-share';
import isEmail from 'validator/lib/isEmail';

import './scss/Share.css';

const SPACE_KEY = 32;
const ENTER_KEY = 13;
const DELETE_KEY = 46;
const BACKSPACE_KEY = 8;

export default class ShareModal extends Component {
  state = {
    modal: true,
    emails: [],
    email: '',
    emailError: '',
  };

  handleKeyDown = e => {
    const { keyCode } = e;
    const { email, emails } = this.state;
    const didUserEnterEmail = keyCode === SPACE_KEY || keyCode === ENTER_KEY;
    const didUserDeleteEmail =
      (keyCode === BACKSPACE_KEY || keyCode === DELETE_KEY) && emails.length && !email;

    if (didUserEnterEmail)
      isEmail(email)
        ? this.setState({
            emails: [...emails, email],
            emailError: '',
            email: '',
          })
        : this.setState({ emailError: 'Oops is this a valid email.?' });

    if (didUserDeleteEmail) this.removeEmail(emails.length - 1);
  };

  addEmail = e => this.setState({ email: e.target.value });

  removeEmail = emailKeyToBeRemoved =>
    this.setState({
      emails: this.state.emails.filter((email, key) => key !== emailKeyToBeRemoved),
    });

  sendInvitation = e => {
    //submit to api
    const { emails } = this.state;
    const emailTo = emails[0];
    const emailCC = emails.splice(1).toString();
    const trekLink = window.location.href;
    // TRACK INVITE FREINDS
    window.open(
      'mailto:' +
        emailTo +
        '?cc=' +
        emailCC +
        '&subject=' +
        'Invitation to join a trek' +
        '&body=' +
        trekLink
    );
  };

  toggle = () => {
    this.props.closeAfterToggle();
    this.setState({
      modal: !this.state.modal,
    });
  };
  handleEmail = event => this.setState({ email: event.target.value });
  render() {
    const shareUrl = window.location.href;
    const title = 'This is so awesome!';

    const { email, emails, modal } = this.state;

    return (
      <Modal isOpen={modal} className="share-modal" toggle={this.toggle}>
        <ModalHeader toggle={this.toggle}>INVITE FRIENDS OR SHARE THIS TREK</ModalHeader>
        <ModalBody>
          <p>Invite Friends Through Their Email Addresses</p>

          <InputGroup>
            <Input
              type="email"
              name="email"
              id="email"
              placeholder="Enter the email addresses"
              value={email}
              onKeyDown={this.handleKeyDown}
              onChange={this.handleEmail}
              multiple
            />
          </InputGroup>

          <div className="email-list">
            <ul>
              {emails.map((singleEmail, i) => (
                <li key={i}>
                  {singleEmail}
                  <span onClick={() => this.removeEmail(i)}>
                    <i className="icon icon-hg-cross" />
                  </span>{' '}
                </li>
              ))}
            </ul>
          </div>

          <p>
            <Button color="yellow" onClick={this.sendInvitation}>
              SEND INVITATION
            </Button>
          </p>
          <hr />
          <div className="social-share-box">
            <p>Share this trek through social media</p>
            <ul>
              <li>
                <FacebookShareButton url={shareUrl} quote={title}>
                  <FacebookIcon size={40} round />
                </FacebookShareButton>
              </li>
              <li>
                <TwitterShareButton url={shareUrl} title={title}>
                  <TwitterIcon size={40} round />
                </TwitterShareButton>
              </li>
              <li>
                <GooglePlusShareButton url={shareUrl}>
                  <GooglePlusIcon size={40} round />
                </GooglePlusShareButton>
              </li>
            </ul>
          </div>
        </ModalBody>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Share/Share.jsx